import { render, staticRenderFns } from "./EstimateTable.vue?vue&type=template&id=533b1b63&scoped=true"
import script from "./EstimateTable.vue?vue&type=script&lang=js"
export * from "./EstimateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533b1b63",
  null
  
)

export default component.exports